import styled from "@emotion/styled";
import { tokens } from "../../../design-system/tokens";

const SwitchWrapper = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  cursor: pointer;

  &:has(input:disabled) {
    cursor: not-allowed;
  }
`;

const SwitchLabel = styled.div`
  position: absolute;
  top: 0;
  left: -50px;

  font-size: ${tokens.typography.fontSize.sm};
`;

// Input oculto
const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + span {
    background: ${tokens.colors.gradient.primary};
    box-shadow: ${tokens.shadows.md};
  }

  &:checked + span:before {
    transform: translateX(16px);
    background-color: ${tokens.colors.blue[800]};
  }

  &:focus + span {
    box-shadow: 0 0 0 2px ${tokens.colors.blue[200]};
  }

  &:disabled + span {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

// Estilo del Slider
const SwitchSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 1px;
  left: 0;
  right: 1px;
  bottom: 0;
  background: ${tokens.colors.basics[500]};
  border-radius: 125px;
  transition: ${tokens.transitions.normal};
  box-shadow: ${tokens.shadows.sm};

  &:before {
    position: absolute;
    content: "";
    height: 15px;
    width: 15px;
    left: 5px;
    bottom: 2px;
    background-color: ${tokens.colors.basics[0]};
    transition: ${tokens.transitions.normal};
    border-radius: 50%;
  }
`;

type SwitchProps = {
  id?: string;
  isChecked: boolean;
  onChange: () => void;
  disabled?: boolean;
  "aria-label"?: string;
  label?: string;
};

export const Switch = ({
  id,
  isChecked,
  onChange,
  disabled = false,
  "aria-label": ariaLabel,
  label,
}: SwitchProps) => {
  return (
    <SwitchWrapper>
      {label && <SwitchLabel>{label}</SwitchLabel>}
      <SwitchInput
        id={id}
        type="checkbox"
        checked={isChecked}
        onChange={onChange}
        disabled={disabled}
        aria-label={ariaLabel}
      />
      <SwitchSlider />
    </SwitchWrapper>
  );
};
